/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmBatchesCancel } from "../../funcs/llmBatchesCancel.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CancelBatchRequest$inboundSchema,
};

export const tool$llmBatchesCancel: ToolDefinition<typeof args> = {
  name: "llm-batches-cancel",
  description: `Cancel a batch

Cancels an in-progress batch. The batch status changes to cancelling, and remaining requests will not be processed.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmBatchesCancel(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
